import { publicConfig } from '@public-config';

import { TokenMeta, User } from 'models';
import { AuthenticationHelpers } from 'helpers/AuthenticationHelpers';
import { ServiceHelpers } from 'helpers/ServiceHelpers';

import { ApiService } from 'services/ApiService';
import { LocalStorageService } from 'services/LocalStorageService';
import { UserService } from 'services/UserService';

const AuthenticationService = {
    navigate: ServiceHelpers.createNavigator(AuthenticationHelpers.urls),

    logout: async (reason?: 'expired') => {
        await ApiService.post(`${publicConfig.urls.api}/users/magic-logout`);

        if (reason === 'expired') {
            window.location.href = `/login?reason=expired&redirect=${window.location.pathname}`;

            return;
        }

        window.location.href = '/';
    },

    login: async (token: string) => {
        return await ApiService.post<
            User & {
                redirect: string;
            }
        >(`${publicConfig.urls.api}/users/magic-login-verify`, { token }, { throwError: true });
    },

    clearRedirect: async (userId: string) => {
        await ApiService.post(`${publicConfig.urls.api}/users/${userId}/clear-login-redirect`);
    },

    sendMagicTokenLogin: (
        email: string,
        otherData = {} as TokenMeta,
        redirect?: string,
        autojoin?: {
            team: string;
            code: string;
        },
    ) => {
        return ApiService.post(
            `${publicConfig.urls.api}/users/magic-login`,
            {
                email,
                source: location.toString(),
                redirect: redirect || new URLSearchParams(window.location.search).get('redirect') || undefined,
                autojoin,
                ...otherData,
            },
            { throwError: true },
        );
    },

    getMagicLoginToken: (email: string, code: string) =>
        ApiService.post(
            `${publicConfig.urls.api}/users/magic-login-get-token`,
            {
                email,
                code,
            },
            { throwError: true, hideConsoleError: true },
        ),

    getFallbackGoofy: () => {
        const goofy = LocalStorageService.get<string>('fallback-goofy');

        if (goofy) {
            return goofy;
        }

        const newGoofy = 'Anonymous ' + Math.random().toString(36).substring(2, 15);
        LocalStorageService.store('fallback-goofy', newGoofy);

        return newGoofy;
    },
};

export { AuthenticationService };
